// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';


import { maintenanceOperationApi } from '../lib/api';

export const CLEAR_MAINTENANCE_OPERATION =
'vehicles/maintenance-operation/clear';
export const SET_MAINTENANCE_OPERATION = 'vehicles/maintenance-operation/set';

const initialState = null;

const clearMaintenanceOperationAction = createAction(CLEAR_MAINTENANCE_OPERATION);
const setMaintenanceOperationAction = createAction(SET_MAINTENANCE_OPERATION);

const maintenanceOperationSlice = createSlice({
  name: 'maintenanceOperation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(setMaintenanceOperationAction, (state, { payload }) => payload).
    addCase(clearMaintenanceOperationAction, () => initialState);
  }
});

export const maintenanceOperationActions = {
  clear: clearMaintenanceOperationAction,
  set: setMaintenanceOperationAction
};

export const clear = () => (dispatch) =>
dispatch(maintenanceOperationActions.clear());

export const addMaintenanceOperation = (
maintenanceOperation,
groupId) =>
async (
dispatch,
getState) =>
{
  const addedMaintenanceOperation = await maintenanceOperationApi.addMaintenanceOperation(
    {
      ...maintenanceOperation,
      groupId
    }
  );
  dispatch(maintenanceOperationActions.set(addedMaintenanceOperation));
};

export const updateMaintenanceOperation = (
maintenanceOperation) =>
async (
dispatch,
getState) =>
{
  const updatedMaintenanceOperation = await maintenanceOperationApi.updateMaintenanceOperation(
    maintenanceOperation
  );
  dispatch(maintenanceOperationActions.set(updatedMaintenanceOperation));
};

export const fetchMaintenanceOperation = (
id) =>
async (dispatch) => {
  const maintenanceOperation = await maintenanceOperationApi.fetchMaintenanceOperation(
    id
  );
  dispatch(maintenanceOperationActions.set(maintenanceOperation));
};

export default maintenanceOperationSlice.reducer;
